import {
	schedule,
	types,
	countHighPriorityTasks,
	countMediumPriorityTasks,
	countAllHighPriorityTasks,
	countAllMediumPriorityTasks
} from './scheduler';
import log from './log';
import {
	getHostPendingNetworkActionCount,
	getPendingNetworkActionCount
} from '@servicenow/ui-internal';
import {getConfigItem, configConstants} from '@servicenow/ui-config';

const {
	WHEN_COMPONENT_IS_IDLE_TIMEOUT,
	WHEN_COMPONENT_IS_IDLE_THROTTLE,
	WHEN_COMPONENT_IS_IDLE_MIN_INTERVAL
} = configConstants;
const timeout = getConfigItem(WHEN_COMPONENT_IS_IDLE_TIMEOUT);
const throttle = getConfigItem(WHEN_COMPONENT_IS_IDLE_THROTTLE);
const interval = getConfigItem(WHEN_COMPONENT_IS_IDLE_MIN_INTERVAL);
const {WHEN_COMPONENT_IS_IDLE, WHEN_ALL_COMPONENTS_IDLE} = types;

const check = el => {
	return new Promise(resolve => {
		schedule({
			fn() {
				resolve(
					getHostPendingNetworkActionCount(el) +
						countHighPriorityTasks(el) +
						countMediumPriorityTasks(el)
				);
			},
			type: WHEN_COMPONENT_IS_IDLE,
			meta: {el, interactionId: 'componentIdleCheck'}
		});
	});
};

const pause = () =>
	new Promise(resolve => {
		setTimeout(() => resolve(), throttle);
	});

const checkAll = () => {
	return new Promise(resolve => {
		schedule({
			fn() {
				resolve(
					getPendingNetworkActionCount() +
						countAllMediumPriorityTasks() +
						countAllHighPriorityTasks()
				);
			},
			type: WHEN_ALL_COMPONENTS_IDLE,
			meta: {el: {}, interactionId: 'allComponentsIdleCheck'}
		});
	});
};

export function whenAllComponentsIdle(payload = {}) {
	return new Promise(resolve => {
		schedule({
			async fn() {
				let busy = true;
				let didPause = false;
				const {withTimeOutInfo = false} = payload;
				const timeoutId = setTimeout(() => {
					busy = false;
					resolve(withTimeOutInfo ? {didPause, timedOut: true} : didPause);
				}, timeout);

				while (busy) {
					busy = await checkAll();
					if (busy) {
						didPause = true;
						await pause();
					}
				}

				clearTimeout(timeoutId);
				resolve(withTimeOutInfo ? {didPause, timedOut: false} : didPause);
			},
			type: WHEN_ALL_COMPONENTS_IDLE,
			meta: {el: {}, interactionId: 'whenAllComponentsIdle'}
		});
	});
}

export default function whenComponentIsIdle(el) {
	return new Promise(resolve => {
		schedule({
			async fn() {
				let busy = true;
				const timeoutId = setTimeout(() => {
					log('whenComponentIsIdle timed out.', {
						host: el,
						origin: 'whenComponentIsIdle'
					});
					busy = false;
					resolve(el);
				}, timeout);

				while (busy) {
					const start = Date.now();
					busy = await check(el);
					const end = Date.now();
					// throttle in case of network activity, i.e. something is pending, but component is otherwise idle
					// if not there will be numerous unnecessary checks while waiting for network request to complete
					if (busy && end - start < interval) await pause();
				}

				clearTimeout(timeoutId);
				resolve(el);
			},
			type: WHEN_COMPONENT_IS_IDLE,
			meta: {el, interactionId: 'whenComponentIsIdle'}
		});
	});
}
